import React, { ReactNode, VFC } from 'react';

interface Props {
  isShow: boolean;
  children: ReactNode;
}
// Compound pattenと呼ばれる手法を使用
// https://qiita.com/seya/items/d08b8a6c12f3e71d5971
// より宣言的に条件分岐を書きたい場合に使用する
const SimpleCompound: VFC<Props> = ({ isShow, children }: Props) => {
  return <>{isShow ? children : null}</>;
};

export default SimpleCompound;
